import { GlButton } from '@gitlab/ui';
import { i18nPolicyText } from '../../constants';
import EscalationPolicyHelpState from './escalation_policy_help_state.vue';
import EscalationPolicyCollapsedState from './escalation_policy_collapsed_state.vue';
export default {
    name: 'EscalationPoliciesEmptyState',
    i18n: i18nPolicyText,
    components: {
        GlButton,
        EscalationPolicyCollapsedState,
        EscalationPolicyHelpState
    },
    data () {
        return {
            showHelp: false
        };
    },
    methods: {
        toggleHelpState () {
            this.showHelp = !this.showHelp;
        }
    }
};
